// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testimonial-container {
  width: 50%;
  padding-right: 35px;
}
.testimonial-container .custom-card {
  position: relative;
  height: 382px;
}
.testimonial-container .custom-card .content {
  padding-bottom: 60px;
}
.testimonial-container .custom-card .content p {
  font-size: 20px;
  font-style: italic;
  line-height: 181.818%;
  letter-spacing: 1.1px;
}
.testimonial-container .custom-card .writter {
  display: flex;
  justify-content: center;
  position: absolute;
  left: 0;
  bottom: -30px;
  width: 100%;
}
.testimonial-container .custom-card .writter .writter-photo {
  width: 100px;
  height: 100px;
  overflow: hidden;
  border-radius: 50%;
}
.testimonial-container .custom-card .writter .writter-info {
  padding-left: 30px;
}
.testimonial-container .custom-card .writter .name {
  font-size: 14px;
  font-style: normal;
  padding-top: 16px;
}
.testimonial-container .custom-card .writter .designation {
  font-size: 12px;
  font-style: normal;
}

@media only screen and (min-width: 0px) and (max-width: 1024px) {
  .testimonial-container {
    padding-right: 16px;
  }
  .testimonial-container .custom-card .content p {
    font-size: 20px;
  }
}
@media only screen and (min-width: 0px) and (max-width: 768px) {
  .testimonial-container {
    width: 100%;
    padding-right: 0;
  }
  .testimonial-container .custom-card {
    height: auto;
  }
}
@media only screen and (min-width: 0px) and (max-width: 767px) {
  .testimonial-container .custom-card .content p {
    font-size: 12px;
  }
  .testimonial-container .custom-card .writter {
    bottom: -16px;
  }
  .testimonial-container .custom-card .writter .writter-photo {
    width: 70px;
    height: 70px;
  }
  .testimonial-container .custom-card .writter .name {
    font-size: 12px;
    padding-top: 10px;
  }
  .testimonial-container .custom-card .writter .designation {
    font-size: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/IntroMessage/IntroMessage.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,mBAAA;AACJ;AAAI;EACE,kBAAA;EACA,aAAA;AAEN;AADM;EACE,oBAAA;AAGR;AAFQ;EACE,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;AAIV;AADM;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;AAGR;AAFQ;EACE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AAIV;AAFQ;EACE,kBAAA;AAIV;AAFQ;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;AAIV;AAFQ;EACE,eAAA;EACA,kBAAA;AAIV;;AAEA;EACE;IACE,mBAAA;EACF;EAEU;IACI,eAAA;EAAd;AACF;AAMA;EACE;IACE,WAAA;IACA,gBAAA;EAJF;EAKE;IACE,YAAA;EAHJ;AACF;AAOA;EAIY;IACI,eAAA;EARd;EAWM;IACI,aAAA;EATV;EAUU;IACI,WAAA;IACA,YAAA;EARd;EAUU;IACI,eAAA;IACA,iBAAA;EARd;EAUU;IACI,eAAA;EARd;AACF","sourcesContent":[".testimonial-container{\r\n    width: 50%;\r\n    padding-right: 35px;\r\n    .custom-card{\r\n      position: relative;\r\n      height: 382px;\r\n      .content{\r\n        padding-bottom: 60px;\r\n        p{\r\n          font-size: 20px;\r\n          font-style: italic;\r\n          line-height: 181.818%;\r\n          letter-spacing: 1.1px;        \r\n        }      \r\n      } \r\n      .writter{\r\n        display: flex;\r\n        justify-content: center;\r\n        position: absolute;\r\n        left: 0;\r\n        bottom: -30px;\r\n        width: 100%;\r\n        .writter-photo{\r\n          width: 100px;\r\n          height: 100px;\r\n          overflow: hidden;\r\n          border-radius: 50%;\r\n        }\r\n        .writter-info{\r\n          padding-left: 30px;\r\n        }\r\n        .name{\r\n          font-size: 14px;\r\n          font-style: normal;\r\n          padding-top: 16px;\r\n        }\r\n        .designation{\r\n          font-size: 12px;\r\n          font-style: normal;\r\n        }\r\n      }  \r\n    }\r\n  }\r\n\r\n@media only screen and (min-width: 0px) and (max-width: 1024px) {\r\n  .testimonial-container{\r\n    padding-right: 16px;\r\n    .custom-card{\r\n        .content{\r\n            p{\r\n                font-size: 20px;\r\n            }\r\n        }\r\n    }\r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 0px) and (max-width: 768px) {\r\n  .testimonial-container{\r\n    width: 100%;\r\n    padding-right: 0;\r\n    .custom-card{\r\n      height: auto;\r\n    }\r\n  }  \r\n}\r\n\r\n@media only screen and (min-width: 0px) and (max-width: 767px) {\r\n  .testimonial-container{\r\n    .custom-card{\r\n        .content{\r\n            p{\r\n                font-size: 12px;\r\n            }\r\n        }\r\n        .writter{\r\n            bottom: -16px;\r\n            .writter-photo{\r\n                width: 70px;\r\n                height: 70px;\r\n            }\r\n            .name{\r\n                font-size: 12px;\r\n                padding-top: 10px;\r\n            }\r\n            .designation{\r\n                font-size: 10px;\r\n            }\r\n        }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
